import {HttpClient} from "@angular/common/http";
import {Injectable} from '@angular/core';
import {Observable} from "rxjs";
import {environment} from "../../../environments/environment";
import {Industry, IndustryCategory, SelectableCategory} from "../../core/model/industry.model";
import {BaseService} from "../../core/services/base.service";

@Injectable({
  providedIn: 'root'
})
export class IndustriesService extends BaseService{

  baseUrl: string = `${environment.apiSharedServicesHost}/api/public/retailer-industries`;

  constructor(private http: HttpClient) {
    super();
  }

  /**
   * Get all enabled industries for the current offering
   */
  getAllEnabledIndustries(): Observable<IndustryCategory[]> {
    return this.http.get<IndustryCategory[]>(this.baseUrl);
  }

  /**
   * Get all selectable options for offering configuration (including disabled industries)
   */
  getAllSelectableOptionsForOffering(): Observable<SelectableCategory[]> {
    return this.http.get<SelectableCategory[]>(`${this.baseUrl}/config`);
  }
}
